import React from 'react';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './FooterLink.css';

export default function FooterLink({ text = '', link = '#', logo = null, hideLinkText = false }) {
  const isTwitter = link.includes('twitter');
  const hideLinkTextClassName = hideLinkText ? 'hideFooterLinkText' : '';
  return (
    <li className="footerLinkItem">
      <a
        href={link}
        onClick={() => trackEvent(TRACKING_ENUMS.EVENT_FOOTERLINK_CLICKED, { page_item_title: text })}
        className={`footerLink ${logo ? 'footerLinkWithImage' : ''}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {logo && (
          <img
            className="footerLinkImage"
            width={isTwitter ? '22' : '28'}
            height={isTwitter ? '16' : '20'}
            src={logo}
            alt={text}
          />
        )}
        <span className={`footerLinkText ${hideLinkTextClassName}`}>{text}</span>
      </a>
    </li>
  );
}
